"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var AdminStudentViewNotesController = /** @class */ (function () {
    function AdminStudentViewNotesController($stateParams, UserService, UsersModel, $sce, FlashService, student) {
        var _this = this;
        this.handleAddNoteChange = this.handleAddNoteChange.bind(this);
        this.studentNotesPageChanged = this.studentNotesPageChanged.bind(this);
        this.addNote = this.addNote.bind(this);
        this.getRole = this.getRole.bind(this);
        this.$stateParams = $stateParams;
        this.student = student;
        this.$sce = $sce;
        this.currentUser = UserService.getCurrentUser();
        this.FlashService = FlashService;
        this.UsersModel = UsersModel;
        this.submitting = false;
        this.note = {
            content: "",
            allowed_roles: {
                students: false,
                instructors: false,
                administrators: true,
                staff: true
            }
        };
        this.studentNotes = {
            currentPage: 0,
            page_by: 5,
            data: [],
            total: 0,
        };
        UsersModel.getStudentNotes(this.$stateParams.userId).then(function (response) {
            _this.studentNotes.data = response.notes.data;
            _this.studentNotes.total = response.notes.total;
            _this.studentNotes.currentPage = response.notes.current_page;
        });
    }
    AdminStudentViewNotesController.prototype.formatNoteContent = function (note) {
        return this.$sce.trustAsHtml(note);
    };
    AdminStudentViewNotesController.prototype.handleAddNoteChange = function (data) {
        this.note.content = data.html;
    };
    AdminStudentViewNotesController.prototype.deleteNote = function (index, note) {
        var _this = this;
        if (note.id) {
            this.submitting = true;
            this.UsersModel.removeStudentNote(this.student.id, note.id).then(function (response) {
                _this.FlashService.setMessage({
                    'type': 'success',
                    'message': response.message
                });
                _this.studentNotes.data = _this.studentNotes.data.filter(function (n) {
                    return note.id !== n.id;
                });
                _this.submitting = false;
            }).catch(function (Error) {
                _this.submitting = false;
            });
        }
        else {
            this.studentNotes.data.splice(index, 1);
        }
    };
    AdminStudentViewNotesController.prototype.getRole = function (role) {
        if (role === 1) {
            return 'Students';
        }
        if (role === 3) {
            return 'Instructors';
        }
        if (role === 4) {
            return 'Owners';
        }
        if (role === 5) {
            return 'Administrators';
        }
        if (role === 9) {
            return 'Staff';
        }
        return 'Owner';
    };
    AdminStudentViewNotesController.prototype.addNote = function () {
        var _this = this;
        this.submitting = true;
        this.UsersModel.addStudentNote(this.student.id, this.note).then(function (response) {
            _this.FlashService.setMessage({ type: 'success', message: response.message });
            _this.studentNotes.data.push(response.note);
            _this.submitting = false;
            _this.note = {
                content: "",
                allowed_roles: {
                    students: false,
                    instructors: false,
                    administrators: true,
                    staff: true
                }
            };
        }).catch(function (Error) {
            _this.submitting = false;
        });
    };
    AdminStudentViewNotesController.prototype.studentNotesPageChanged = function () {
        var _this = this;
        this.submitting = true;
        this.UsersModel.getStudentNotes(this.student.id, { page: this.studentNotes.currentPage }).then(function (response) {
            _this.studentNotes.data = response.notes.data;
            _this.studentNotes.total = response.notes.total;
            _this.studentNotes.currentPage = response.notes.current_page;
            _this.submitting = false;
        }).catch(function (Error) {
            _this.submitting = false;
        });
    };
    AdminStudentViewNotesController.prototype.getStudentAge = function () {
        if (this.student === null) {
            return 100;
        }
        if (typeof this.student.usermeta === 'undefined') {
            return 100;
        }
        if (typeof this.student.usermeta.dob === 'undefined') {
            return 100;
        }
        var dob = (0, moment_1.default)(this.student.usermeta.dob, 'YYYY-MM-DD').toDate();
        return (0, moment_1.default)(new Date()).diff((0, moment_1.default)(dob), 'years');
    };
    return AdminStudentViewNotesController;
}());
AdminStudentViewNotesController.$inject = ['$stateParams', 'UserService', 'UsersModel', '$sce', 'FlashService', 'student'];
exports.default = AdminStudentViewNotesController;
